import theme from '../theme';

export const dragginColor = {
  color: theme.palette.info.light,
};
